module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "header-nav"
  }, [_c('router-link', {
    staticClass: "nav-item",
    attrs: {
      "to": "/home",
      "onclick": "gaStat('导航', '首页')"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$t('home')) + "\n        ")]), _vm._v(" "), _c('router-link', {
    staticClass: "nav-item",
    attrs: {
      "to": "/about",
      "onclick": "gaStat('导航', '关于我们')"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$t('about')) + "\n        ")]), _vm._v(" "), _c('router-link', {
    staticClass: "nav-item",
    attrs: {
      "to": "/game",
      "onclick": "gaStat('导航', '游戏中心')"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$t('center')) + "\n        ")]), _vm._v(" "), _c('router-link', {
    staticClass: "nav-item",
    attrs: {
      "to": "/business",
      "onclick": "gaStat('导航', '商务合作')"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$t('business')) + "\n        ")]), _vm._v(" "), _c('router-link', {
    staticClass: "nav-item",
    attrs: {
      "to": "/news",
      "onclick": "gaStat('导航', '新闻资讯')"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$t('news')) + "\n        ")])], 1), _vm._v(" "), (_vm.global.isTest) ? _c('button', {
    staticClass: "btn",
    staticStyle: {
      "min-width": "80px"
    },
    on: {
      "click": _vm.clearCache
    }
  }, [_vm._v("清除缓存")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "154px",
      "height": "36px",
      "display": "inline-block"
    }
  })])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header-logo"
  }, [_c('div', {
    staticClass: "eg-logo",
    staticStyle: {
      "text-decoration": "none",
      "min-width": "460px"
    }
  }, [_c('img', {
    staticStyle: {
      "margin": "0 10px 10px 10px"
    },
    attrs: {
      "src": require("../../../static/img/nav/mengguo_logo.png"),
      "width": "185"
    }
  }), _vm._v(" "), _c('img', {
    staticStyle: {
      "margin": "0 10px 10px 10px"
    },
    attrs: {
      "src": require("../../../static/img/nav/header_logo.png"),
      "width": "170"
    }
  }), _vm._v(" "), _c('img', {
    staticStyle: {
      "margin": "0 10px 0 0",
      "width": "80px",
      "height": "73px"
    },
    attrs: {
      "src": require("../../../static/img/nav/logo1.png")
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-44f4ac9e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/nav/Header.vue
// module id = 375
// module chunks = 13